import { TinyColor } from '@ctrl/tinycolor'
import { Button, ConfigProvider } from 'antd'

/**
 * 主题按钮组件
 *
 * 这是一个带有渐变主题色的按钮组件，基于Ant Design Button封装。
 * 使用ConfigProvider提供自定义主题，支持渐变色、悬停效果和激活状态。
 *
 * @param props - 传递给Button组件的所有属性
 *
 * 使用场景：
 * 1. 主要操作按钮 - 页面中的主要操作按钮
 * 2. 表单提交按钮 - 表单的提交和确认按钮
 * 3. 模态框按钮 - 弹窗中的确认按钮
 * 4. 导航按钮 - 页面导航和跳转按钮
 * 5. 功能按钮 - 各种功能操作的按钮
 * 6. 卡片操作按钮 - 卡片组件中的操作按钮
 * 7. 工具栏按钮 - 工具栏中的主要功能按钮
 * 8. 引导按钮 - 用户引导流程中的按钮
 *
 * 使用示例：
 * ```tsx
 * // 基础用法
 * <ThemeBtn onClick={handleClick}>
 *   确认操作
 * </ThemeBtn>
 *
 * // 带图标
 * <ThemeBtn icon={<SaveOutlined />} onClick={handleSave}>
 *   保存
 * </ThemeBtn>
 *
 * // 禁用状态
 * <ThemeBtn disabled={!isValid} onClick={handleSubmit}>
 *   提交
 * </ThemeBtn>
 *
 * // 加载状态
 * <ThemeBtn loading={isSubmitting} onClick={handleSubmit}>
 *   提交中...
 * </ThemeBtn>
 * ```
 */

// 主题色配置：蓝紫色渐变
const colors3 = ['#3B74FB', '#6468F7', '#9659F2']

/**
 * 生成悬停状态的颜色（比原色亮5%）
 * @param colors - 原始颜色数组
 * @returns 悬停状态颜色数组
 */
const getHoverColors = (colors: string[]) => colors.map(color => new TinyColor(color).lighten(5).toString())

/**
 * 生成激活状态的颜色（比原色暗5%）
 * @param colors - 原始颜色数组
 * @returns 激活状态颜色数组
 */
const getActiveColors = (colors: string[]) => colors.map(color => new TinyColor(color).darken(5).toString())

const App = (props: any) => (
  <ConfigProvider
    theme={{
      components: {
        Button: {
          colorPrimary: `linear-gradient(116deg,  ${colors3.join(', ')})`,
          colorPrimaryHover: `linear-gradient(116deg, ${getHoverColors(colors3).join(', ')})`,
          colorPrimaryActive: `linear-gradient(116deg, ${getActiveColors(colors3).join(', ')})`
          // lineWidth: 0,
        }
      }
    }}
  >
    <Button shape="round" type="primary" {...props}>
      {props.children}
    </Button>
  </ConfigProvider>
)

export default App
